import Skeleton from '@mui/material/Skeleton';

const LoadingSkeleton = ({ children, isLoading }) => {
	return isLoading ? (
		<Skeleton variant="rounded" component="div" width="100%">
			{children}
		</Skeleton>
	) : (
		children
	);
};

export default LoadingSkeleton;
